<template>
    <b-form-group :label="label" label-for="description">
        <div :class="validationClass">
            <quill-editor
                id="description"
                :value="value"
                @input="onUpdateValue($event)"
                :options="editorOption"
                :disabled="disabled"
                :class="{ 'max-height': maxHeight }"
            />
        </div>
        <b-form-invalid-feedback :state="state">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import { debounce } from 'lodash'
export default {
    name: 'Description',
    props: {
        value: {
            type: String,
            default: '',
        },
        state: {
            type: Boolean,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        toolbar: {
            type: Array,
            default: () => [
                'bold',
                'italic',
                'underline',
                'strike',
                { color: [] },
                { list: 'ordered' },
                { list: 'bullet' },
                { header: [1, 2, 3, 4, false] },
                { header: 1 },
                { header: 2 },
            ],
        },
        maxHeight: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            editorOption: {
                modules: {
                    toolbar: this.toolbar,
                },
                placeholder: this.placeholder,
            },
        }
    },
    methods: {
        onUpdateValue(value) {
            this.$emit('update:value', value)
            this.$emit('change-value', value)
        },
    },
    computed: {
        validationClass() {
            if (this.state === null) return null

            return this.state ? 'is-valid' : 'has-error'
        },
    },
    watch: {
        value: {
            handler: debounce(function() {
                this.$emit('change-debounced', this.value)
            }, 500),
        },
    },
}
</script>

<style scoped>
.ql-snow {
    border-color: #e4e7ea !important;
}

.is-valid {
    border: 1px solid #4dbd74;
}

.has-error {
    border: 1px solid #f86c6b;
}
.max-height {
    max-height: 200px;
    overflow-y: auto;
}
</style>
